import React, { useEffect, useState } from "react";
import { Button, Form, Row } from "react-bootstrap";
import { FaMinus, FaTrashAlt } from "react-icons/fa";

const ClinicServiceForm = ({ service, isNumber, isValue }) => {
  const [updatedServiceLabel, setUpdatedServiceLabel] = useState(service.label);
  const [price, setPrice] = useState(service.price);
  const [isHide, setIsHide] = useState(service.isHide);

  const deleteService = () => {
    if (window.confirm("You will delete this service. Are you sure?")) {
      setIsHide(true);
    }
  };

  useEffect(() => {
    service.label = updatedServiceLabel;
    service.isHide = isHide;
    service.price = price;
  }, [updatedServiceLabel, isHide, price]);
  return (
    <>
      {!isHide && (
        <Row>
          <Form.Group className="col-6">
            <Form.Control
              type="text"
              placeholder="type your service here"
              value={updatedServiceLabel}
              onChange={(e) => setUpdatedServiceLabel(e.target.value)}
              isValid={updatedServiceLabel}
            ></Form.Control>
          </Form.Group>

          <Form.Group className="col-4">
            <Form.Control
              type="number"
              value={price}
              onChange={(e) => setPrice(e.target.value)}
              isValid={price}
            ></Form.Control>
          </Form.Group>

          <Form.Group className="col-2 align-self-end text-center">
            <Button
              className="btn btn-danger"
              onClick={() => deleteService(service)}
            >
              <FaTrashAlt />
            </Button>
          </Form.Group>
        </Row>
      )}
    </>
  );
};

export default ClinicServiceForm;
